import { useDroppable } from "@dnd-kit/core";
import { WeekDaysEnum } from "../../types/types";
import './weekday.css';

export const mapDays = {
  [WeekDaysEnum.monday]: 'pn',
  [WeekDaysEnum.tuesday]: 'wt',
  [WeekDaysEnum.wednesday]: 'śr',
  [WeekDaysEnum.thursday]: 'czw',
  [WeekDaysEnum.friday]: 'pt',
  [WeekDaysEnum.saturday]: 'sb',
  [WeekDaysEnum.sunday]: 'nd',
}

const WeekdayDropZone = ({ day }: { day: WeekDaysEnum }) => {
  const { setNodeRef, isOver } = useDroppable({ id: day });

  return (
    <div
      ref={setNodeRef}
      className={`weekday-drop ${isOver ? "active" : ""}`}
    >
      {mapDays[day].toUpperCase()}
    </div>
  );
};


export const WeekdayOverlay = () => (
  <div className="weekday-overlay">
    {Object.values(WeekDaysEnum).map(day => (
      <WeekdayDropZone key={day} day={day} />
    ))}
  </div>
);
